// react
import { Map } from "immutable";

// dependencies

// utils

const initialState = Map();

export default function page(state = initialState, action) {
	switch (action.type) {
		case "PAGEUPDATE:CHANGE_STATE": {
			return state.setIn(action.keyPath, action.value);
		}

		case "PAGEUPDATE:MERGE_CHANGE_STATE": {
			const currentVal = state.getIn(action.keyPath, Map());
			return state.setIn(action.keyPath, currentVal.merge(action.value));
		}

		default:
			return state;
	}
}
